export default "__VITE_ASSET__OBB7wL7a__"